import TypeDashboardSection from "./type-detail/TypeDashboardSection";
import Footer from "./component/Footer";
import { useEffect, useState } from "react";
import Animation from '../assets/animation.JPG'
import { apiHandler, apiImageHandler } from "./api/APIHandler";
import photo from '../assets/layout.png'

export default function Exhibition() {
    const [isVisible, setIsVisible] = useState(false);
    const [data, setData] = useState()
    const [image1, setImage1] = useState()
    const [image2, setImage2] = useState()
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 4500); // 5000 milliseconds = 5 seconds

    return () => clearTimeout(timer); // Clean up the timer on component unmount
  }, []);

  useEffect(() => {
    // Fetch photo URL from an API
    const fetchData = async () => {
        try {
            const data = await apiHandler('items/exhibition_list');
            const image1 = await apiImageHandler(data.header);
            const image2 = await apiImageHandler(data.footer);
            setImage1(image1)
            setImage2(image2)
            setData(data);
        } catch (error) {
            console.error('Error fetching photo URL:', error);
        }
    };

    fetchData();
  }, []);
    return (
        <div className='overflow-x-hidden overflow-y-hidden relative'>
                    <div className='h-[100vh] w-[100vw] bg-black overflow-hidden' style={isVisible ? {display: 'none'} : {}}>
                        <img src={Animation} className='custom-animation absolute object-cover object-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10' alt='photo'/>
                    </div>
                    
                    <div className={isVisible ? '' : 'hidden'}>
                        <div>
                            <TypeDashboardSection/>
                        </div>
                        <div className="flex justify-center items-center px-[8vw] w-full h-full"><img src={image1} className="w-full h-full object-cover"></img></div>
                        {
                          data ? <div className=' px-[8vw] py-[4vw]' dangerouslySetInnerHTML={{ __html: data.content }}></div>: <></>
                        }
                        <div className="flex justify-center items-center w-full px-[8vw] mb-14"><img src={image2} className="w-full h-full object-cover"></img></div>
                        <div>
                            <Footer/>
                        </div>
                    </div>
                </div>
      )

}